import script from "./CobranzaTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaTopbar.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaTopbar.vue?vue&type=style&index=0&id=427811a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427811a4"]])

export default __exports__